<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Territory Post Code List</h4>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>

            <dxi-item>
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"> Region(s) </div>
                    <div class="dx-field-value">
                        <dx-tag-box #regions [dataSource]="salesSubRegions"
                            (onValueChanged)="onChanged_salesRegion($event)" [showSelectionControls]="true"
                            displayExpr="name" valueExpr="salesRegionId">
                        </dx-tag-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <dx-button class="ap-blue-btn" type="default" (onClick)="getTerritoriesBySalesRegion()"
                        text="Get Territories">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="2"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"> Territory(s)</div>
                    <div class="dx-field-value">
                        <dx-drop-down-box #territoryDropDown [(value)]="territoryValue"
                        placeholder="Select a value..." [showClearButton]="true"
                        [dataSource]="territories" valueExpr="territoryId" displayExpr="territoryName"
                        (onValueChanged)="onChanged_Territory($event)"
                        validationMessagePosition="top">
                        <div *dxTemplate="let data of 'content'">
                            <dx-list #territorylist [dataSource]="territories" [height]="300"
                                [selectionMode]="'all'" [selectAllMode]="'allPages'"
                                [showSelectionControls]="true" keyExpr="territoryId"
                                displayExpr="territoryName"
                                (onSelectionChanged)="onsegmentListSelectionChanged($event)"
                                scrollingEnabled="true">
                            </dx-list>
                        </div>
                    </dx-drop-down-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item class="marginB10">
                <dxi-location [row]="0" [col]="3"></dxi-location>
                <div class="dx-field">
                    <dx-button class="ap-blue-btn" [disabled]="disableReportBtn" type="default" (onClick)="getReports()"
                        text="View Reports">
                    </dx-button>
                </div>

            </dxi-item>
        </dx-responsive-box>
        <hr />
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div *ngIf="showGrid">
        <div class="leftmargin">
            <h4>Territory-PostCode List as of {{currentDate}} </h4>
        </div>
        <dx-data-grid id="gridContainer" class="fixGridHght" [dataSource]="dataSource" [allowColumnReordering]="true"
            [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true"
            [rowAlternationEnabled]="true" [columnHidingEnabled]="false" [allowColumnResizing]="false">
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
            <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
                [showInfo]="true" [showNavigationButtons]="true">
            </dxo-pager>
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button class="ap-blue-btn" text="Reset" (onClick)="resetFilters()">
                    </dx-button>
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxi-column dataField="countryID" caption="Country"></dxi-column>
            <dxi-column dataField="salesRegion" caption="Sales Region"></dxi-column>
            <dxi-column dataField="stateProv" caption="State"></dxi-column>
            <dxi-column dataField="county" caption="County"></dxi-column>
            <dxi-column dataField="zip" caption="Postal Code"></dxi-column>
            <dxi-column dataField="territory" caption="Territory"></dxi-column>           
        </dx-data-grid>
    </div>
</div>